import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        justify-content: center;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { media } from '~layout';
var LogoContainer = styled.div.withConfig({
  displayName: "LogoContainer",
  componentId: "klvhaj-0"
})(["align-items:center;display:flex;height:100%;justify-content:left;", ""], media.md(_templateObject()));
export default LogoContainer;